<template>
  <div class="knowledge-practice-student-detail-page">
    <title-bar back title="答题表现">
      <el-button type="primary" @click="viewPlan">查看计划</el-button>
    </title-bar>

    <div class="main">
      <training-overview-info v-if="training" :training="training"></training-overview-info>
      <training-clazz-static-info
        :value="clazzId"
        :clazz-options="clazzOptions"
        :clazz-summary-items="clazzSummaryItems"
        @change="updateClazzId"
      ></training-clazz-static-info>
      <list-page class="list-page" :data="studentList" :limit="query.limit">
        <el-table-column label="学生姓名">
          <template v-slot="{ row }">
            {{ row.name }}
          </template>
        </el-table-column>

        <el-table-column label="年级班级">
          <template v-slot="{ row }">
            {{ row.class_name }}
          </template>
        </el-table-column>

        <el-table-column label="性别">
          <template v-slot="{ row }">
            {{ row.gender }}
          </template>
        </el-table-column>

        <el-table-column label="完成情况">
          <template v-slot="{ row }">
            <div class="completion-status">
              <div :class="['status', statusClass(row.completion_status)]"></div>
              {{ row.completion_status }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="action" label="更多操作" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="navToLiveCourseRecords(row)">详情</el-button>
          </template>
        </el-table-column>
      </list-page>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import ListPage from '@/components/ListPage.vue'
import { Clazz, IClazzStaticSummary, IStudentStaticSummary, ITrainingListItem } from 'kuaidong-model'
import { Emit } from 'vue-property-decorator'
import { AWinter2023 } from 'kuaidong-api'
import { IUser, SchoolUtil, UnitUtil } from 'kuaidong-lib'
import { NewCourseLiveService } from 'kuaidong-service'

@Component({
  components: {
    TitleBar,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
    ListPage,
  },
})
export default class KnowledgePracticeStudentDetailPage extends BasePage {
  @Prop({ type: Object, required: true })
  training!: ITrainingListItem

  @Prop({ type: String, required: true })
  challengeClassId!: string

  @Prop({ type: Array, required: true })
  clazzOptions!: {
    value: number
    label: string
    challenge_id: string
    challenge_class_id: string
  }[]

  @Prop({ type: String, required: true })
  from!: 'KNOWLEDGE' | 'SPECIAL_EXERCISE'

  query = {
    limit: 20,
  }
  staticInfo: IClazzStaticSummary | null = null
  summaryItems: IStudentStaticSummary[] = []
  clazzId: number | null = null
  currentChallengeClassId = this.challengeClassId

  actions = [
    {
      label: '查看题目',
      action: 'examDetail',
    },
  ]

  get currentClazz() {
    return this.clazzOptions.find((option) => {
      return option.challenge_class_id === this.currentChallengeClassId
    })
  }

  get clazzSummaryItems() {
    if (this.staticInfo === null) {
      return [
        { value: '-', title: '学生人数' },
        { value: '-', title: '已完成' },
        { value: '-', title: '未完成' },
        { value: '-', title: '完成率' },
      ]
    } else {
      return [
        { value: this.staticInfo?.students_count, title: '学生人数' },
        { value: this.staticInfo?.completion_count, title: '已完成' },
        { value: this.staticInfo?.uncompleted_count, title: '未完成' },
        { value: this.staticInfo.completion_rate, title: '完成率' },
      ]
    }
  }

  get filterClazzName() {
    return this.currentClazz ? this.currentClazz.label : '全部'
  }

  get studentList() {
    if (this.summaryItems) {
      return this.summaryItems.map((item) => {
        return {
          user_id: item.student_vo.user_id,
          name: this._show_student_name(item.student_vo as any),
          class_name: item.class_vo.note_name || item.class_vo.name,
          gender: item.student_vo.gender === 'M' ? '男' : '女',
          completion_status: item.completion_status,
        }
      })
    }
    return []
  }

  get service() {
    return NewCourseLiveService
  }

  showClazzName(clazz: Clazz) {
    return clazz.note_name || clazz.name || SchoolUtil.buildClazzName(clazz.grade_no, clazz.class_no)
  }

  statusClass(status: string) {
    if (status === '未完成' || status === '未开始') {
      return 'un-finished'
    } else if (status === '完成') {
      return 'finished'
    } else if (status === '进行中') {
      return 'in-process'
    } else {
      return ''
    }
  }

  formatRate(rate: number) {
    return UnitUtil.percent(rate)
  }

  @Emit('navToStudentStatic')
  navToStudentStaticsPage(clazz: Clazz) {
    return clazz
  }

  navToLiveCourseRecords(student: IUser) {
    this.$router.push({
      name: 'pe_knowledge_practice_student_result',
      query: {
        userId: student.user_id,
        chanllengeClassID: this.challengeClassId,
      },
    })
  }

  viewPlan() {
    if (this.from === 'KNOWLEDGE') {
      this.$router.push({
        name: 'pe_knowledge_exam_detail',
        query: {
          id: this.staticInfo?.paper_id,
        },
      })
    }
  }

  async created() {
    if (this.currentClazz) {
      this.clazzId = this.currentClazz.value
    }

    this.fetchStudentList()
    this.fetchClazzStaticInfo()
  }

  async fetchClazzStaticInfo() {
    this.staticInfo = await AWinter2023.trainingClassSummary(this.training.group_id, this.clazzId)
  }

  async fetchStudentList() {
    this.summaryItems = await AWinter2023.classStudentList(this.currentChallengeClassId)
  }

  updateClazzId(clazzId: number | null) {
    this.clazzId = clazzId

    const targetClazz = this.clazzOptions.find((option) => {
      return option.value === this.clazzId
    })
    this.currentChallengeClassId = targetClazz ? targetClazz.challenge_class_id : ''
    this.fetchStudentList()
    this.fetchClazzStaticInfo()
  }
}
</script>
<style lang="less">
.knowledge-practice-student-detail-page {
  > .main {
    padding: 22px 24px;
    background: #fff;

    > .list-page {
      margin-top: 24px;
      padding: 0;
      > .el-table {
        > .el-table__body-wrapper {
          > .el-table__body {
            > tbody {
              > .el-table__row {
                > td {
                  > .cell {
                    > .completion-status {
                      display: flex;
                      align-items: center;
                      > .status {
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        margin-right: 4px;
                        &.un-finished {
                          background: #f24b53;
                        }
                        &.finished {
                          background: #3bb528;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
